import { ViewStyle } from 'react-native';
import { RotationMap } from './Triangle.types';

export const staticStyle: ViewStyle = {
  width: 0,
  height: 0,
  backgroundColor: 'transparent',
  borderStyle: 'solid',
  borderLeftColor: 'transparent',
  borderRightColor: 'transparent',
};

export const rotationMap: RotationMap = {
  up: 0,
  down: 180,
  left: -90,
  right: 90,
};
